import {
    doktorse as doktorseComponentLibraryTheme,
} from "@collabodoc/component-library";
import logo from "../Images/Logo/doktorse_light.png"


const doktorse = {
    ...doktorseComponentLibraryTheme,
    logo: logo,
    searchbar: {
        backgroundColor: doktorseComponentLibraryTheme.colors.tertiary,
        borderColor: doktorseComponentLibraryTheme.colors.primary
    },
    copybutton: {
        backgroundColor: doktorseComponentLibraryTheme.colors.success,
        borderColor: doktorseComponentLibraryTheme.colors.success
    },
    card: {
        cardHeader: {
            color: doktorseComponentLibraryTheme.colors.primary
        }
    },
    sectionHeader:{
        color: doktorseComponentLibraryTheme.colors.primary
    },
    typeahead: {
        backgroundColor: doktorseComponentLibraryTheme.colors.tertiary,
        borderColor: doktorseComponentLibraryTheme.colors.secondary,
        color: doktorseComponentLibraryTheme.colors.secondary
    },
    patientList: {
        row: {
            hover: {
                backgroundColor: doktorseComponentLibraryTheme.colors.tertiary,
                color: doktorseComponentLibraryTheme.colors.secondary
            }
        },
        oddRow: {
            backgroundColor: "#F3F3F3",
        },
        evenRow: {
            backgroundColor: doktorseComponentLibraryTheme.colors.white
        },
        pagination: {
            lineHeight: '35px',
            active:{
                backgroundColor: doktorseComponentLibraryTheme.colors.focus,
                color: 'white'
            }
        },
        color: doktorseComponentLibraryTheme.colors.primary
    },
    datePicker: {
        hover: {
            backgroundColor: doktorseComponentLibraryTheme.colors.tertiary,
            color: doktorseComponentLibraryTheme.colors.primary,
        },
        selected: {
            backgroundColor: doktorseComponentLibraryTheme.colors.tertiary,
            color: doktorseComponentLibraryTheme.colors.primary,
        },
        today: {
            backgroundColor: doktorseComponentLibraryTheme.colors.primary,
            color: 'white',
        }
    },
    tippyTheme: {
        backgroundColor: doktorseComponentLibraryTheme.colors.primary
    }
};

export default doktorse;